import { Grid, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import ServicePackage from '../configuration/service-package';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const Upgrade: React.FC = () => {
    const [searchParams] = useSearchParams();
    const transactionStatus = searchParams.get('vnp_TransactionStatus');

    useEffect(() => {
        if (transactionStatus === '00') {
            toast.success('Thanh toán thành công');
        } else if (transactionStatus) {
            toast.error('Thanh toán không thành công!');
        }
    }, [transactionStatus]);
    return (
        <>
            <Grid container>
                <Grid item md={12}>
                    <Typography
                        variant="h5"
                        sx={{
                            textAlign: 'center',
                            fontSize: '2rem',
                            color: 'primary.main',
                            fontWeight: 'bold',
                        }}
                    >
                        Nâng cấp gói dịch vụ
                    </Typography>
                </Grid>
                <Grid item md={12}>
                    <ServicePackage
                        monthTabText="Mua theo tháng"
                        yearTabText="Mua theo năm"
                        isUpgrade={true}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default Upgrade;
